import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";

export type SnackbarType = "success" | "error";

export interface SnackbarData {
    message: string;
    type: SnackbarType;
}

@Component({
    selector: "app-snackbar",
    templateUrl: "./snackbar.component.html",
    styleUrls: ["./snackbar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonModule]
})
export class SnackbarComponent {
    readonly data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
    readonly snackBarRef = inject(MatSnackBarRef);
}
